import React from "react";

type PlanProp = {
    amount: number;
    payable_amount: number;
    discounted_amount: number;
    currency: string;
  }

type Props = {
    planName: string;
    plan: PlanProp;
    taxLabel?: string;
    tax?: number;
    nextBillDate?: string;
    onChangeClick?: () => void;
    buttonLoading: boolean,
    onPay?: () => void;
};
function getFormattedNextBillingDate(planType:string) {
  const date = new Date();

  if (planType === "monthly") {
    date.setMonth(date.getMonth() + 1);
  } else if (planType === "annual") {
    date.setFullYear(date.getFullYear() + 1);
  }

  const day = date.getDate();
  const month = date.toLocaleString("en-US", { month: "short" }); // e.g., "Aug"
  const year = date.getFullYear();

  // Get day suffix
  const suffix =
    day % 10 === 1 && day !== 11
      ? "st"
      : day % 10 === 2 && day !== 12
      ? "nd"
      : day % 10 === 3 && day !== 13
      ? "rd"
      : "th";

  return `${day}${suffix} ${month} ${year}`;
}
export default function PaymentSummaryCard({
    planName,
    plan,
    taxLabel = "GST (18%)",
    buttonLoading = false,
    onChangeClick,
    onPay,
}: Props) {
    return (
        <div className="max-w-sm w-full rounded-3xl border border-gray-200 bg-white p-1 p-5 shadow-sm">
            <div
                className={`border-[2px] shadow-sm rounded-lg p-2 flex items-center justify-between transition h-[100px] border-[#6355ff]`}>
                <div className="flex items-center space-x-3">
                    <div>
                        <div className='flex items-center  space-x-3'>
                            <span className="text-lg font-semibold">{planName.toUpperCase()}</span>
                        </div>

                        <span className="bg-[#dfdcff] text-[#6355ff] text-xs font-medium px-2 py-1 rounded">
                            Saved ~
                            {Math.round(
                          (1 -
                            plan.discounted_amount /
                            plan.amount) *
                          100
                        )}
                            %
                        </span>
                    </div>

                </div>
                <div className="text-right">
                    <p className="text-2xl font-bold">
                        {plan.currency}
                      {plan.discounted_amount}/mo
                    </p>
                    <p className="text-gray-500 line-through">
                        {plan.currency}
                      {plan.amount}/mo
                    </p>
                </div>

            </div>

            <p
                onClick={onChangeClick}
                className="text-right w-full text-sm underline text-slate-900/90 hover:text-slate-900 mt-2"
            >
                <span className="cursor-pointer">Change</span>
            </p>

            {/* Lines */}
            <div className="mt-3 space-y-4">
                <Row label="Subtotal" value={`${plan.currency}${plan.payable_amount.toLocaleString()}`} />
                {plan.currency == "₹" && <Row label={taxLabel} value={`${plan.currency}${(Math.round(plan.payable_amount*.18)).toLocaleString()}`} />}

                <hr className="border-gray-200" />

                <div className="flex items-baseline justify-between">
                    <div>
                        <div className="text-lg font-semibold text-slate-900">Total Due Today</div>
                        <div className="text-sm text-slate-500 mt-1">
                            Billed next on {getFormattedNextBillingDate(planName)}
                        </div>
                    </div>
                    <div className="text-lg font-semibold text-slate-900">
                        {plan.currency}
                        {plan.currency == "₹" ? Math.round(plan.payable_amount*1.18).toLocaleString() : plan.payable_amount}
                    </div>
                </div>

                <button
                    disabled={buttonLoading}
                    onClick={onPay}
                    className={`mt-5 w-full rounded-2xl bg-[#6355ff] px-4 py-3 text-white font-semibold shadow hover:bg-[#4838fc] active:[#4838fc] ${buttonLoading?'opacity-50': ''}`}
                >
                    {buttonLoading && <span className="loading_spinner"></span>}
                    Upgrade to Pro
                </button>
            </div>
        </div >
    );
}

function Row({ label, value }: { label: string; value: string }) {
    return (
        <div className="flex items-center justify-between">
            <span className="text-base font-medium text-slate-900">{label}</span>
            <span className="text-base text-slate-900">{value}</span>
        </div>
    );
}
